import React from 'react'

import { graphql } from 'gatsby'

import BodyTextTemplate from '../components/bodyTextTemplate'

import Layout from '../components/layout'

export const query = graphql`
    query($slug: String) {
        contentfulBlogPost (slug: {
            eq: $slug
        }) {
            title
            body {
                raw
            }
            date
        }
        allContentfulAsset {
            nodes {
                contentful_id
                title
                gatsbyImageData
            }
        }
    }
`

const BlogPost = ({ data }) => {
    const assetData = data.allContentfulAsset.nodes

    const { 
        title,
        body,
        date
     } = data.contentfulBlogPost

    return (
        <Layout showHeader={true}>
            <section>
                <div className="mx-6 blogpost-mobile">
                    <div className="my-6">
                        <h1 className="is-size-1 is-size-2-mobile has-text-centered">{title}</h1>
                        <h6 className="is-size-6 has-text-centered">{date}</h6>
                    </div>

                    <div className="column is-10 is-offset-1">
                        <BodyTextTemplate richTextField={body} assetData={assetData} />
                    </div>
                </div>
            </section>
        </Layout>
    )
}

export default BlogPost